exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-star-rating-star[data-v-ac246ba6] {\n    overflow: visible !important;\n}\n", ""]);

// exports
